import React from 'react';
import { Slide } from 'react-slideshow-image';
import "../styles/AboutMeSection.scss"; 
import 'react-slideshow-image/dist/styles.css'
import {
    JakeAndBri, 
    JakeBriBachi, 
    JakeBriPeru, 
    JakeAtHPStore, 
    JakeBriWalkDogs, 
    JakeBriZitiUnderTheBridge, 
    JakeCaughtAFoulBall,  
    JakeOnARock, 
    JakeWithZiti, } from '../../../Components/Images/IndexFile';

const slideImages = [
    {
        url: JakeWithZiti,
        caption: "Jake with his best girl Ziti",
        position: "top center"
    },
    {
        url: JakeAndBri,
        caption: "Jake and his Wife Brianna",
        position: "center center"
    },
    {
        url: JakeBriBachi,
        caption: "Jake and Brianna playing bocce",
        position: "top center"
    },
    {
        url: JakeBriPeru,
        caption: "Jake and Brianna in Peru",
        position: "top center"
    }, 
    {
        url: JakeAtHPStore,
        caption: "Jake at the Harry Potter store in NYC",
        position: "top center"
    },
    {
        url: JakeBriWalkDogs,
        caption: "Jake and Brianna walking their dogs",
        position: "center center"
    },
    {
        url: JakeBriZitiUnderTheBridge,
        caption: "Jake and Brianna under a bridge with their dog ziti after getting engaged",
        position: "center center"
    },
    {
        url: JakeCaughtAFoulBall,
        caption: "Jake caught a foul ball at the mets game",
        position: "center center"
    },
    {
        url: JakeOnARock,
        caption: "Jake took Ziti and a foster dog on a walk",
        position: "top center"
    },
];

const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    height: '600px',
    borderRadius: '25px',
};

const buttonStyle = {
    display: "none"
};

const sliderProperties = {
    prevArrow: <button style={{ ...buttonStyle }}></button>,
    nextArrow: <button style={{ ...buttonStyle }}></button>
}


const AboutMeSection = () => {

    const AboutMeFunTitle = "The Man Behind the Keyboard.";
    const AboutMeFunParagraph = "Hi, I'm Jake — a Front End Web Developer since 2016 with experience building sites both from scratch and within a CMS. I specialize in building marketing websites, both large and small, to help companies grow to their full potential. I've worked across software companies and marketing agencies, which has shaped how I approach projects: I like seeing a problem from every angle before landing on the right solution, and I genuinely love building beautiful, functional websites. Outside of client work, I'm a self-proclaimed nerd (video games, anime, and tech in general never get old), and when I'm not at the keyboard you'll usually find me on a disc golf course, snowboarding, or checking out a new local brewery. I'd love the chance to build something great for you — let's talk about your project.";
    
    return (
        <div id="about" className="about-me-section">
            <h3 className="about-me-skills-title">ABOUT</h3>
            <div className="about-me-content">
                <h2 className="about-me-fun-header">{AboutMeFunTitle}</h2>
                <p className="about-me-fun-paragraph">{AboutMeFunParagraph}</p>
            </div>
            <div className="about-me-images">
                <div className="slide-container">
                    <Slide {...sliderProperties}>
                    {slideImages.map((slideImage, index)=> (
                        <div key={index}>
                        <div style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})`, 'backgroundPosition': `${slideImage.position}` }}>
                        </div>
                        </div>
                    ))} 
                    </Slide>
                </div>
            </div>
        </div>
    )

}

export default AboutMeSection; 


